import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetStatsEnvironment } from '../fleet-stats-environment';
import { vehicleStatsSchema } from '../schemas/vehicle-stats.schema';

/**
 * Gets all vehicles with unassigned configuration profiles in an account
 * @returns Vehicles with unassigned configuration profiles
 */
export function getDashboardVehicleStatsUnassignedConfigurationProfiles(
  this: unknown
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetStatsEnvironment.resolve(
          this
        ).dashboardVehicleStatsUnassignedConfigurationProfilesUrl,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(z.array(vehicleStatsSchema)));
}
